import React from "react";
export type IBreedDetailSubheader = {
    subtitle: string;
    title: string;
    fact?: string;
    specie: string;
};
const BreedDetailSubheader = ({ subtitle, title, fact, specie }: IBreedDetailSubheader) => {
    return (
        <div className="BreedDetailSubheader flex items-center justify-between">
            <div className="BreedDetailSubheader-text">
                <div className="flex flex-row items-center gap-6 lg:flex-col lg:items-start">
                    <div className="">
                        {subtitle && (
                            <p className="BreedDetailSubheader-subtitle mb-1 text-overline font-bold uppercase tracking-overline text-accent-secondary-medium">{subtitle}</p>
                        )}
                        <h2 className="BreedDetailSubheader-title text-md !font-bold capitalize tracking-md lg:text-lg lg:tracking-lg">{title}</h2>
                    </div>

                    {fact && (
                        <div className="rounded-lg bg-accent-secondary-background py-2 px-3 text-center text-sm font-bold text-accent-secondary-medium lg:p-4 ">
                            <div className="text-caption text-caption lg:text-subheadline1 lg:tracking-subheadline1">Affects</div>
                            <div className="text-subheadline1 tracking-subheadline1 lg:text-lg lg:tracking-lg">{fact}</div>
                            <div className="text-caption tracking-caption lg:text-subheadline1 lg:tracking-subheadline1">of {specie}s</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BreedDetailSubheader;
